import React from 'react';
import { Route, withRouter } from 'react-router';
import LedgermapList from "./components/ledgermapList";
import LedgermapForm from "./components/ledgermapForm";

const Ledgermap = () => {
    return (
        <>
            <Route path="/ledgermap/list" component={withRouter(LedgermapList)} />
            <Route path="/ledgermap/edit/:id" component={LedgermapForm} />
            <Route path="/ledgermap/clone/:id" component={LedgermapForm} />
            <Route path="/ledgermap/create" component={LedgermapForm} />
        </>
    )
};

export default Ledgermap;